export default __webpack_public_path__ + "static/media/hexagon-inner-7.f120dc52.svg";